export enum Role {
  collaborator = 'collaborator',
  branch_owner = 'branch_owner',
  auditor = 'auditor',
  admin = 'admin',
}

const roleMap: { [key in Role]: string } = {
  [Role.collaborator]: 'Colaborador',
  [Role.branch_owner]: 'Gerente de sucursal',
  [Role.auditor]: 'Auditor',
  [Role.admin]: 'Administrador',
}

export const RoleToString = (val: Role) => {
  return roleMap[val] || '';
}
